export default {
  currentProject: {
    project: {
      id: 0,
      title: '',
    },
    videos: [],
  }
}
